import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import { LoadingState, StateMessage } from '@/components/StateMessage/StateMessage';
import styles from './ProjectsPage.module.css';

export function OpsPage() {
  const opsQ = useQuery({
    queryKey: ['platform-ops'],
    queryFn: () =>
      apiFetch<{
        api_health: string;
        queue_depth: { name: string; depth: number }[];
        failed_jobs_24h: { name: string; failed: number }[];
        latest_migration: { name: string; run_on: string } | null;
        mail_bounces_7d: number;
      }>('/api/platform/ops'),
    retry: false,
  });

  if (opsQ.isLoading) return <LoadingState label="Ops laden…" />;
  if (opsQ.isError) {
    return (
      <StateMessage
        title="Geen toegang"
        message="Ops-dashboard is alleen voor org-beheerders."
      />
    );
  }

  const data = opsQ.data!;

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Platform ops</h1>
      <p className={styles.mutedSmall}>Geen PII — queue, migraties en job-fouten.</p>

      <section className={styles.card}>
        <h2>Health</h2>
        <p>
          API: <code>{data.api_health}</code>
        </p>
        {data.latest_migration ? (
          <p className={styles.mutedSmall}>
            Laatste migratie: {data.latest_migration.name} ·{' '}
            {new Date(data.latest_migration.run_on).toLocaleString('nl-NL')}
          </p>
        ) : null}
        <p className={styles.mutedSmall}>Mail bounces (7d, lead_events): {data.mail_bounces_7d}</p>
      </section>

      <section className={styles.card}>
        <h2>Queue depth (pg-boss)</h2>
        {!data.queue_depth.length ? <p className={styles.mutedSmall}>Geen jobs in queue.</p> : null}
        <ul className={styles.list}>
          {data.queue_depth.map((r) => (
            <li key={r.name} className={styles.listItem}>
              {r.name}: {r.depth}
            </li>
          ))}
        </ul>
      </section>

      <section className={styles.card}>
        <h2>Mislukt (24u)</h2>
        {!data.failed_jobs_24h.length ? <p className={styles.mutedSmall}>Geen failed jobs.</p> : null}
        <ul className={styles.list}>
          {data.failed_jobs_24h.map((r) => (
            <li key={r.name} className={styles.listItem}>
              {r.name}: {r.failed}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
